import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["monthNames", "weekdayNames", "monthsToDisplay", "stacked", "disabledDates", "interactiveDisabledDates", "initialDisplayDate"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import subDays from 'date-fns/subDays';
import differenceInCalendarMonths from 'date-fns/differenceInCalendarMonths';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import isSameDay from 'date-fns/isSameDay';
import throttle from 'lodash/fp/throttle';
import Dayzed from 'dayzed';
import { Flex, Box } from "../";
import isDateInRange from "./lib/isDateInRange";
import CalendarNav from "./components/CalendarNav";
import CalendarMonth from "./components/CalendarMonth";

var NOOP = function NOOP() {
  return false;
};

var throttled = throttle(10);

var DateRangePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DateRangePicker, _React$Component);

  var _super = _createSuper(DateRangePicker);

  function DateRangePicker(props) {
    var _this;

    _classCallCheck(this, DateRangePicker);

    _this = _super.call(this, props);

    _this.onOffsetChanged = function (offset) {
      return _this.setState({
        offset: offset
      });
    };

    _this.onMouseLeaveOfCalendar = function () {
      return _this.setState({
        hoveredDate: null
      });
    };

    _this.onMouseEnterOfDay = throttled(function (hoveredDate) {
      if (_this.state.startDate && !_this.state.endDate) {
        _this.setState({
          hoveredDate: hoveredDate.date
        });
      }
    });

    _this.onDateSelected = function (_ref) {
      var selectable = _ref.selectable,
          date = _ref.date;
      if (!selectable) return;
      var _this$state = _this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate,
          isSettingStartDate = _this$state.isSettingStartDate,
          isSettingEndDate = _this$state.isSettingEndDate;

      if (!startDate || isSettingStartDate) {
        _this.selectStartDate(date);
      } else if (!endDate || isSettingEndDate) {
        _this.selectEndDate(date);
      } else {
        _this.resetWithStartDate(date);
      }

      _this.notifyRangeSelection();
    };

    _this.notifyRangeSelection = function () {
      var _this$state2 = _this.state,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate;
      var onRangeSelected = _this.props.onRangeSelected;

      if (startDate && endDate && onRangeSelected) {
        onRangeSelected({
          startDate: startDate,
          endDate: endDate
        });
      }
    };

    _this.selectStartDate = function (startDate) {
      var endDate = startDate <= _this.state.endDate ? _this.state.endDate : null;
      var endDateRequiresSelection = endDate === null;

      _this.setState({
        startDate: startDate,
        endDate: endDate,
        isSettingStartDate: false,
        isSettingEndDate: endDateRequiresSelection,
        hoveredDate: null
      });
    };

    _this.selectEndDate = function (date) {
      if (date <= _this.state.startDate) {
        _this.resetWithStartDate(date);
      } else {
        _this.setState({
          endDate: date,
          isSettingEndDate: false,
          hoveredDate: null
        });
      }
    };

    _this.resetWithStartDate = function (startDate) {
      _this.setState({
        startDate: startDate,
        endDate: null,
        isSettingStartDate: false,
        isSettingEndDate: true,
        hoveredDate: null
      });
    };

    _this.isInRange = function (date) {
      var _this$state3 = _this.state,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate,
          isSettingStartDate = _this$state3.isSettingStartDate,
          hoveredDate = _this$state3.hoveredDate;
      return isDateInRange({
        startDate: startDate,
        endDate: endDate,
        isSettingStartDate: isSettingStartDate,
        hoveredDate: hoveredDate,
        date: date
      });
    };

    var _this$props = _this.props,
        initialStartDate = _this$props.initialStartDate,
        initialEndDate = _this$props.initialEndDate,
        initialDisplayDate = _this$props.initialDisplayDate;

    var _startDate = initialStartDate ? startOfDay(initialStartDate) : null;

    var _endDate = initialEndDate ? endOfDay(initialEndDate) : null;

    var focusDate = _startDate || _endDate || initialDisplayDate;
    _this.state = {
      hoveredDate: null,
      offset: differenceInCalendarMonths(focusDate, initialDisplayDate),
      isSettingStartDate: props.isSettingStartDate,
      isSettingEndDate: props.isSettingEndDate,
      startDate: _startDate,
      endDate: _endDate
    };
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state4 = this.state,
          startDate = _this$state4.startDate,
          endDate = _this$state4.endDate;
      var prevStartDate = prevState.startDate,
          prevEndDate = prevState.endDate;
      var startDateDidUpdate = !isSameDay(startDate, prevStartDate);
      var endDateDidUpdate = !isSameDay(endDate, prevEndDate);

      if (startDateDidUpdate || endDateDidUpdate) {
        this.props.onChangeDates({
          startDate: startDate,
          endDate: endDate
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          monthNames = _this$props2.monthNames,
          weekdayNames = _this$props2.weekdayNames,
          monthsToDisplay = _this$props2.monthsToDisplay,
          stacked = _this$props2.stacked,
          disabledDates = _this$props2.disabledDates,
          interactiveDisabledDates = _this$props2.interactiveDisabledDates,
          initialDisplayDate = _this$props2.initialDisplayDate,
          rest = _objectWithoutProperties(_this$props2, _excluded);

      var _this$state5 = this.state,
          startDate = _this$state5.startDate,
          endDate = _this$state5.endDate,
          offset = _this$state5.offset;
      var selectedDates = [startDate, endDate];
      return /*#__PURE__*/React.createElement(Dayzed, _extends({}, rest, {
        selected: selectedDates,
        date: initialDisplayDate,
        offset: offset,
        onDateSelected: this.onDateSelected,
        onOffsetChanged: this.onOffsetChanged,
        monthsToDisplay: monthsToDisplay,
        render: function render(_ref2) {
          var calendars = _ref2.calendars,
              getBackProps = _ref2.getBackProps,
              getForwardProps = _ref2.getForwardProps,
              getDateProps = _ref2.getDateProps;
          if (!calendars.length) return null;
          return /*#__PURE__*/React.createElement(Box, {
            onMouseLeave: _this2.onMouseLeaveOfCalendar,
            position: "relative"
          }, /*#__PURE__*/React.createElement(CalendarNav, {
            prevProps: getBackProps({
              calendars: calendars
            }),
            nextProps: getForwardProps({
              calendars: calendars
            })
          }), /*#__PURE__*/React.createElement(Flex, {
            flexWrap: "wrap"
          }, calendars.map(function (calendar) {
            return /*#__PURE__*/React.createElement(CalendarMonth, {
              key: "".concat(calendar.month).concat(calendar.year),
              monthsToDisplay: monthsToDisplay,
              monthName: monthNames[calendar.month],
              month: calendar.month,
              year: calendar.year,
              stacked: stacked,
              weekdayNames: weekdayNames,
              weeks: calendar.weeks,
              getDateProps: getDateProps,
              disabledDates: disabledDates,
              interactiveDisabledDates: interactiveDisabledDates,
              onMouseEnterOfDay: _this2.onMouseEnterOfDay,
              isInRange: _this2.isInRange
            });
          })));
        }
      }));
    }
  }]);

  return DateRangePicker;
}(React.Component);

DateRangePicker.defaultProps = {
  monthsToDisplay: 1,
  firstDayOfWeek: 1,
  stacked: false,
  minDate: subDays(new Date(), 1),
  disabledDates: [],
  interactiveDisabledDates: false,
  monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  initialStartDate: null,
  initialEndDate: null,
  initialDisplayDate: new Date(),
  isSettingStartDate: false,
  isSettingEndDate: false,
  onRangeSelected: NOOP,
  onChangeDates: NOOP
};
DateRangePicker.propTypes = {
  monthsToDisplay: PropTypes.number,
  firstDayOfWeek: PropTypes.number,
  stacked: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  disabledDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  interactiveDisabledDates: PropTypes.bool,
  monthNames: PropTypes.arrayOf(PropTypes.string),
  weekdayNames: PropTypes.arrayOf(PropTypes.string),
  initialStartDate: PropTypes.instanceOf(Date),
  initialEndDate: PropTypes.instanceOf(Date),
  initialDisplayDate: PropTypes.instanceOf(Date),
  isSettingStartDate: PropTypes.bool,
  isSettingEndDate: PropTypes.bool,
  onRangeSelected: PropTypes.func,
  onChangeDates: PropTypes.func
};
export default DateRangePicker;